import { GitBranch } from 'lucide-react';
import { useFlow } from './api';

/**
 * How the answers shaped the questions (task 85): each route taken, the answer that took it, and what it
 * skipped or counted as not in place. Shown once a route has been taken.
 */
export function PathCard({ id, enabled }: { id: string; enabled: boolean }) {
  const flow = useFlow(id, enabled);
  const taken = flow.data?.taken ?? [];
  if (!taken.length) return null;
  const c = flow.data!.counts;
  return (
    <section className="card pad" aria-labelledby="path-h">
      <div className="eyebrow row gap" id="path-h">
        <GitBranch size={14} /> How your answers shaped the questions
      </div>
      <p className="muted small">
        {c.skipped + c.implied} {c.skipped + c.implied === 1 ? 'question was' : 'questions were'} not needed
        {c.implied ? `; ${c.implied} of them count as not in place` : ''}.
      </p>
      <ul className="path-list">
        {taken.map((t) => (
          <li key={t.route}>
            <b>{t.label}</b>
            <span className="muted small">
              You answered “{t.answer}” to “{t.from_text}” ·{' '}
              {[
                t.implied.length > 0 && `${t.implied.length} counted as not in place`,
                t.skipped.length > 0 && `${t.skipped.length} skipped`,
              ]
                .filter(Boolean)
                .join(', ')}
            </span>
          </li>
        ))}
      </ul>
    </section>
  );
}
